import embaladoImage from '../../assets/img/embalado.png'
import verificacionImage from '../../assets/img/verificacion.png'
import recepcionImage from '../../assets/img/recepcion.png'
import entregaImage from '../../assets/img/entrega.png'
import girosImage from '../../assets/img/giros.png'
import empresasImage from '../../assets/img/empresas.png'

export const listParecelService = [
    {
        image: embaladoImage,
        title: 'Embalado',
        description: 'Los envíos de encomiendas deben estar embalados correctamente y rotulados para poder ser aceptados.'
    },
    {
        image: verificacionImage,
        title: 'Verificacion',
        description: 'Los usuarios harán entrega de su encomienda al personal del counter. En dicho acto se revisará, con presencia del usuario el contenido de la encomienda a fin de evitar el transporte de material prohibido.'
    },
    {
        image: recepcionImage,
        title: 'Recepción',
        description: 'De no encontrarse productos prohibidos, se procederá a recepcionar la encomienda para su envío al destino solicitado.'
    },
    {
        image: entregaImage,
        title: 'La entrega',
        description: 'La entrega de la encomienda es personal, debe presentar su DNI original del consignado + clave de seguridad.'
    },
    {
        image: girosImage,
        title: 'Giros nacionales',
        description: 'Para recojo de giros mayores a S/. 200.00 soles debe presentar copia de documento de identidad + clave de seguridad.'
    },
    {
        image: empresasImage,
        title: 'Empresas',
        description: 'Debe presentar autorización de la empresa para el retiro de las mercaderías correspondientes, solo mercadería a nombre de una empresa + clave de seguridad.'
    },
]